export default [
  {
    title: "Who is HobbsTech?",
    description:
      "A Software Technology company that builds customized software solution of all scales and sizes, for all businesses",
  },
  {
    title: "When was HobbsTech founded?",
    description: "2017",
  },
  {
    title: "When was HobbsTech incorporated?",
    description: "2018",
  },
  {
    title: "Does HobbsTech have any other branches?",
    description:
      "Yes, HobbsTech is registered, incorporated and fully operates in United Kingdom",
  },
];
